/* swatch-first-colour.js
   Fixes Shopify filter swatches when colour values contain slashes
   e.g. "Black/Black/White/White" -> valid linear-gradient swatch
*/

(function () {
  // Only run where facets exist (collection/search pages)
  function shouldRun() {
    return (
      document.querySelector("#facets-sidebar") ||
      document.querySelector("facet-filters-form") ||
      document.querySelector(".facets__sidebar") ||
      document.querySelector(".facets")
    );
  }

  // A few “special” names that don’t map nicely via keywords
  const SPECIAL = {
    obsidian: "#0b1b3a",
    onix: "#374151",
    anthracite: "#374151",
    carbon: "#374151",
    charcoal: "#374151",
    "medium grey heather": "#6b7280",
    "dark grey melange": "#6b7280",
    "dark grey mélange": "#6b7280",
    vermillion: "#dc2626",
    volt: "#facc15",
  };

  function normalise(raw) {
    return (raw || "")
      .toLowerCase()
      .trim()
      .replace(/\s+/g, " ")
      .replace(/^team\s+/, "")     // team navy -> navy
      .replace(/^tw\s+/, "")       // tw royal -> royal
      .replace(/^sv\s+/, "")       // sv yellow -> yellow
      .replace(/\s+\d+$/, "")      // navy 2 -> navy
      .replace(/[()]/g, "");
  }

  function colourToCss(name) {
    const n = normalise(name);
    if (!n) return "";

    // already a hex?
    if (/^#([0-9a-f]{3}|[0-9a-f]{6})$/i.test(n)) return n;

    // exact special map first
    if (SPECIAL[n]) return SPECIAL[n];

    // keyword grouping (covers most supplier-style names)
    if (n.includes("black")) return "#000000";
    if (n.includes("white")) return "#ffffff";

    if (n.includes("navy") || n.includes("midnight") || n.includes("obsidian"))
      return "#0b1b3a";

    if (
      n.includes("grey") || n.includes("gray") || n.includes("silver") ||
      n.includes("anthracite") || n.includes("onix") || n.includes("carbon") ||
      n.includes("charcoal") || n.includes("heather") || n.includes("melange") || n.includes("mélange")
    ) return "#6b7280";

    if (
      n.includes("red") || n.includes("crimson") || n.includes("scarlet") ||
      n.includes("claret") || n.includes("maroon") || n.includes("burgundy")
    ) return "#dc2626";

    if (
      n.includes("yellow") || n.includes("gold") || n.includes("lime") ||
      n.includes("tour") || n.includes("solar") || n.includes("pulse")
    ) return "#facc15";

    if (
      n.includes("green") || n.includes("emerald") || n.includes("pine") ||
      n.includes("cactus") || n.includes("mint") || n.includes("gecko") || n.includes("spark")
    ) return "#16a34a";

    if (n.includes("orange") || n.includes("fluo")) return "#f97316";

    if (
      n.includes("purple") || n.includes("magenta") || n.includes("pink") ||
      n.includes("fuchsia") || n.includes("beetroot")
    ) return "#7c3aed";

    if (
      n.includes("blue") || n.includes("royal") || n.includes("azure") ||
      n.includes("sky") || n.includes("aqua") || n.includes("cyan") || n.includes("lagoon")
    ) return "#1d4ed8";

    // If it’s a simple CSS named color (rare here), try it anyway
    // (browser will ignore if invalid)
    return n;
  }

  function buildGradientFromTooltip(tooltip) {
    const parts = (tooltip || "")
      .split("/")
      .map((p) => p.trim())
      .filter(Boolean);

    const colours = parts
      .map(colourToCss)
      .filter((c) => c && c !== "transparent");

    if (colours.length === 0) return "";
    if (colours.length === 1) return colours[0];

    // Build equal segments gradient: c1 0-25%, c2 25-50%, etc.
    const n = colours.length;
    const stops = colours
      .map((c, i) => {
        const start = (i * 100) / n;
        const end = ((i + 1) * 100) / n;
        return `${c} ${start}%, ${c} ${end}%`;
      })
      .join(", ");

    return `linear-gradient(to right, ${stops})`;
  }

  function applySwatches(root = document) {
    if (!shouldRun()) return;

    const labels = root.querySelectorAll('label.color-swatch[data-tooltip]');
    labels.forEach((el) => {
      const tooltip = el.getAttribute("data-tooltip") || "";
      const bg = buildGradientFromTooltip(tooltip);

      if (bg) {
        // Your theme uses this CSS variable for swatches
        el.style.setProperty("--swatch-background", bg);
      }
    });
  }

  // Run once
  document.addEventListener("DOMContentLoaded", () => applySwatches());

  // Re-run when filters re-render (Shopify updates DOM after selecting filters)
  let rafId = null;
  const obs = new MutationObserver(() => {
    if (rafId) return;
    rafId = requestAnimationFrame(() => {
      rafId = null;
      applySwatches();
    });
  });

  obs.observe(document.documentElement, { childList: true, subtree: true });
})();
